// extracted by mini-css-extract-plugin
module.exports = {"likes_content":"likesModal_likes_content__1HkVP","content_body":"likesModal_content_body__1dzDd","poster":"likesModal_poster__3QG4G","close":"likesModal_close__gERiZ"};